
export default {
    AWSConfig: {
        //�J����
        //Region: 'ap-northeast-1',
        //UserPoolId: 'ap-northeast-1_Y7ke3tUPf',
        //ClientId: '4pa94dsf3chjsp1v2vvvk4s5nk',
        //IdentityPoolId: 'ap-northeast-1:a496c99d-24de-425d-a402-fb8c9352e657',

        //���؊�
        //Region: 'ap-northeast-1',
        //UserPoolId: 'ap-northeast-1_YmdlZP3d0',
        //ClientId: '4c9n21pf8fjqlil2hig5itg1vq',
        //IdentityPoolId: 'ap-northeast-1:a09c1e9e-6342-42c4-bafc-9d6947b09507',

        //�{�Ԋ�
        Region: 'ap-northeast-1',
        UserPoolId: 'ap-northeast-1_nVYZD7GXt',
        ClientId: '2vke7m3edgn2mpauctli2nm5n4',
        IdentityPoolId: 'ap-northeast-1:d93526e4-3780-4636-a473-61af3d0ea522',

        //�ێ��
        //Region: 'ap-northeast-1',
        //UserPoolId: 'ap-northeast-1_VdbTsi5r8',
        //ClientId: '5imtoql6k0o4k0sek89b5qeuvm',
        //IdentityPoolId: 'ap-northeast-1:64e51bce-21ba-48bf-82ee-e9d35390381f',

    }
}

